import { alias, list, createModelSchema, custom } from "serializr";
import { Schema } from "@/common/Schema";

import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";

import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import { LevelTrack } from "../../level-track/LevelTrack";

export class SmartOfferBundleHiddenTemple extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.HIDDEN_TEMPLE);

        this._currency = null;
        this._lastChancePending = 0;

        this._levelTracks = [];

        this._useCurrencyMergePoints = false;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get lastChancePending() {
        return this._lastChancePending;
    }

    set lastChancePending(value) {
        this._lastChancePending = value;
    }

    get levelTracks() {
        return this._levelTracks;
    }

    set levelTracks(value) {
        this._levelTracks = value;
    }

    get useCurrencyMergePoints() {
        return this._useCurrencyMergePoints;
    }

    set useCurrencyMergePoints(value) {
        this._useCurrencyMergePoints = value;
    }

    valid() {
        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!Number.isInteger(this.lastChancePending) || this.lastChancePending < 0) {
            return false;
        }

        if (!this.levelTracks || this.levelTracks.length === 0) {
            return false;
        }

        if (this.levelTracks.some(v => !v.valid())) {
            return false;
        }

        if (this.useCurrencyMergePoints === undefined || this.useCurrencyMergePoints === null || typeof this.useCurrencyMergePoints !== 'boolean') {
            return false;
        }

        return super.valid();
    }

    empty() {
        return !this.currency && !this.useCurrencyMergePoints && (!this.levelTracks || this.levelTracks.length === 0) && super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleHiddenTemple());
        } else if (target instanceof SmartOfferBundleHiddenTemple) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleHiddenTemple, {
    _currency: alias("currency", CurrencyKindModel.schema()),
    _lastChancePending: alias("last_chance_pending", Schema.primitive()),

    _levelTracks: alias("level_tracks", list(LevelTrack.schema())),

    _useCurrencyMergePoints: alias("use_currency_merge_points", toBoolean()),
});

function toBoolean() {
    return custom(
        (value) => Boolean(value),
        (value) => Boolean(value),
    );
}
